import type { QueryClient } from "@tanstack/react-query";
import { httpBatchLink, type TRPCClient } from "@trpc/client";
import { createTRPCReact, type CreateTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@companion/api/router";
import { getTelegram } from "./lib/telegram.js";

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

export function makeTrpcClient(apiUrl: string): TRPCClient<AppRouter> {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${apiUrl}/trpc`,
        headers() {
          const tg = getTelegram();
          return tg ? { "x-telegram-init-data": tg.initData } : {};
        },
      }),
    ],
  });
}

export type { QueryClient };
